// eslint-disable-next-line import/prefer-default-export
export var ACCEPT_HEADER_VALUE_FOR_DOCUMENTS = 'application/json, application/yaml';


//////////////////
// WEBPACK FOOTER
// ./node_modules/swagger-client/es/constants.js
// module id = 505
// module chunks = 0